import React from 'react';
import { useParallax } from 'react-scroll-parallax';

// Assets
const CATERING_MAN =
  'https://santaplaya-bucket.s3.amazonaws.com/CateringMan.webp';
const BUBBLES_LIGHT =
  'https://santaplaya-bucket.s3.amazonaws.com/bubbles_light.webp';
const OCTOPUS = 'https://santaplaya-bucket.s3.amazonaws.com/Octopus.webp';

const CateringHero: React.FC = () => {
  // Parallax for bubbles (rising up)
  const bubblesRef = useParallax<HTMLDivElement>({
    translateY: [15, -15],
    easing: 'easeInOut',
  });

  // Parallax for octopus (sliding in or drifting horizontally)
  const octopusRef = useParallax<HTMLDivElement>({
    translateX: [0, 30],
    easing: 'easeInOut',
  });

  return (
    <section
      className="
        relative
        w-full
        min-h-[60vh]
        mt-[15vh]
        md:mt-0
        bg-white
        flex
        flex-col md:flex-row 
        items-center
        justify-center
      "
    >
      {/* LEFT SIDE: Text content (stacked in mobile) */}
      <div
        className="
          w-full md:w-3/4 
          flex flex-col
          items-center justify-center 
          p-6 sm:p-12 
          text-center 
          space-y-6 sm:space-y-8 
          z-10
        "
      >
        {/* Small text */}
        <p className="font-prosto text-sea text-base sm:text-xl">
          Bring the vibrant flavors of Santa Playa Mariscos to your next event.
        </p>

        {/* Large heading */}
        <h1
          className="
            text-3xl 
            sm:text-5xl 
            md:text-7xl 
            font-charles 
            text-maroon 
            leading-tight
          "
        >
          Our catering services offer fresh, <br className="hidden sm:block" />
          delicious mexican seafood dishes <br className="hidden sm:block" />
          that will impress your guests.
        </h1>

        {/* Additional text */}
        <p
          className="
            font-prosto 
            text-sea 
            uppercase 
            text-xs 
            sm:text-sm 
            md:text-base 
            tracking-wide 
            max-w-2xl 
            mx-auto
          "
        >
          WHETHER IT’S A CORPORATE GATHERING, WEDDING OR PRIVATE PARTY, WE’VE
          GOT YOU COVERED.
        </p>
      </div>

      {/* RIGHT SIDE: Catering Man image */}
      <div className="relative w-full md:w-1/4 flex justify-center md:justify-end">
        <img
          src={CATERING_MAN}
          alt="Catering Man"
          className="
            w-2/3
            sm:w-1/2
            md:w-[40vw]
            h-auto
            md:absolute 
            md:bottom-0 
            md:right-0 
            z-0
          "
        />
      </div>

      {/* PARALLAX ACCENTS */}

      {/* Bubbles (rise up) - optionally hide on small screens */}
      <div
        ref={bubblesRef.ref}
        className="
          absolute 
          hidden 
          sm:block  /* show from sm: and up */
          right-[20%] 
          top-0
          transform -translate-y-1/2 
          pointer-events-none
        "
      >
        <img
          src={BUBBLES_LIGHT}
          alt="Bubbles Light"
          className="w-20 md:w-[10vw] h-auto opacity-80"
        />
      </div>

      {/* Octopus (bottom-left corner drifting) - optionally hide on small screens */}
      <div
        ref={octopusRef.ref}
        className="
          absolute 
          hidden 
          sm:block
          -left-[6.25%]
          -bottom-[30%]
          pointer-events-none
        "
      >
        <img src={OCTOPUS} alt="Octopus" className="w-40 md:w-[30vw] h-auto" />
      </div>
    </section>
  );
};

export default CateringHero;
